import { tunaEvent } from "@app/tuna";

export const SIGNUP_INTENT_EVENT = "signup_intent";

export function trackSignupIntent(payload: {
  paas: boolean;
  ai: boolean;
}): void {
  tunaEvent(SIGNUP_INTENT_EVENT, JSON.stringify(payload));
}
